var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoParentalRating12 = function SvgIcoParentalRating12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M12 24c6.628 0 12-5.372 12-12 0-6.627-5.372-12-12-12S0 5.373 0 12c0 6.628 5.372 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.047 4.793a7.204 7.204 0 0 1 7.196 7.197 7.204 7.204 0 0 1-7.196 7.197c-3.968 0-7.198-3.229-7.198-7.197s3.23-7.197 7.198-7.197m0-2.399c-5.3 0-9.597 4.296-9.597 9.596s4.296 9.596 9.596 9.596 9.596-4.296 9.596-9.596-4.295-9.596-9.595-9.596"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.792 9.949h-.5q-.342 0-.532-.208a.72.72 0 0 1-.197-.521q.001-.311.197-.532c.127-.148.304-.217.531-.217H9.6c.522 0 .787.266.787.808v5.425c0 .277-.067.483-.206.63-.147.148-.334.217-.581.217-.236 0-.433-.069-.58-.227-.148-.147-.228-.354-.228-.62zm4.74 2.058c.531-.69.787-1.212.787-1.536 0-.187-.042-.342-.157-.453-.164-.16-.836-.457-1.237.565-.093.234-.138.386-.228.514-.099.128-.259.22-.476.24h-.078a.63.63 0 0 1-.463-.187.84.84 0 0 1-.246-.542c0-.63.236-1.172.709-1.615a2.3 2.3 0 0 1 1.654-.66c.62 0 1.143.197 1.585.591.434.394.651.906.651 1.527 0 .364-.069.699-.227 1.024-.148.324-.798 1.132-1.181 1.555-.394.433-.66.758-.828.985h1.674c.227 0 .414.068.542.207a.8.8 0 0 1 .187.542.72.72 0 0 1-.187.512c-.128.148-.315.217-.561.217H12.3c-.62 0-.966-.189-.966-.69 0-.35.139-.542.365-.788.944-.994 1.556-1.654 1.832-2.008"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIcoParentalRating12;